export const USER_UNSUBSCRIBED_PUSH_NOTIFICATIONS = 'uupn'

export const AUTH_COOKIE_NAME = 'connect.sid'
